export default "__VITE_ASSET__Btdjko3m__"